<template>
  <select
    class="lang-selector"
    v-model="selected"
    @change="$emit('change', selected)"
  >
    <option
      v-for="(option, index) in options"
      :key="index"
      :value="option.value"
    >
      {{ option.title }}
    </option>
  </select>
</template>

<script>
export default {
    name: "Select",
    props: {
        options: {
            type: Array,
            required: true
        },
        changes: {
            type: Boolean,
            required: false,
            default: false
        },
        default: {
            require: false
        }
    },
    watch: {
        changes: function () {
            this.selected = this.default;
        }
    },
    data() {
        return {
            selected: ""
        }
    },
    created() {
        this.selected = this.default || this.options[0].value;
    }
};
</script>

<style lang="scss">
.lang-selector {
  background: transparent;
  color: white;
  outline: none;
  width: max-content;
  padding: 2px 22px 2px 2px;
  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyNpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ4IDc5LjE2NDAzNiwgMjAxOS8wOC8xMy0wMTowNjo1NyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkY4MzY3RTNGOUQyNDExRUM5QTY3RDdDOURGOTk4NEUxIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkY4MzY3RTQwOUQyNDExRUM5QTY3RDdDOURGOTk4NEUxIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6RjgzNjdFM0Q5RDI0MTFFQzlBNjdEN0M5REY5OTg0RTEiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6RjgzNjdFM0U5RDI0MTFFQzlBNjdEN0M5REY5OTg0RTEiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5py8drAAAAo0lEQVR42mL8//8/AyWAiYFCMLgMWADEr4HYGY96RyB+BVULAaBAhOLP/yHgKxCbI4nDsAoQf4Cq+QQTR1aQ+R8BQAp1keREgfg2knwJNgNAuB5J0QuorWxAvBdJfAayHgYsTp2ApPgBEK9G4u+FGojXAEYgnv8fE9wCYn509dgMAGFmIF6HpPkV1DsMxBrAAHXqeiB+CcT2uNQxjuYFBoAAAwAJ+H5H38DlUQAAAABJRU5ErkJggg==");
  background-size: 14px;
  background-repeat: no-repeat;
  background-position: right;
  option {
    color: black;
    font-size: 14px;
  }
}
</style>
